import { useGetAgentBalance } from '../../queries';
import { Stack, TextField, Typography } from '@mui/material';
import useLocalization from '../../hooks/useLocalization';
import { useModal } from '../../hooks/useDialog';
import { StyleObj } from '../../@types';
import { getModalProps } from '../../hooks/useAuthForms';
import { useSkin } from '../../contexts/SkinContext';
import BalanceAdjustmentForm from '../organisms/BalanceAdjustmentForm';

const formatBalance = (balance: number, currency: string) => {
  return Intl.NumberFormat('en-US', { style: 'currency', currency }).format(balance);
};

const styles: StyleObj = {
  textField: {
    width: '50%',
    '& .MuiInputBase-input': {
      padding: '10px',
      textAlign: 'end',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'text.primary',
      backgroundColor: 'background.paper',
      WebkitTextFillColor: 'text.primary',
      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'neutral.300',
        '& .MuiInputLabel-root.Mui-disabled': {
          color: 'text.primary',
        },
      },
    },
  },
};

const AgentBalance = ({ userId }: { userId: string }) => {
  const { t } = useLocalization();
  const { data: agentBalance, refetch } = useGetAgentBalance({ userId });
  const mainBalance = agentBalance?.main;
  const balance = formatBalance(mainBalance?.balance || 0, mainBalance?.currency || 'EUR');
  const { openModal } = useModal();
  const { skin } = useSkin();
  const modalProps = getModalProps(skin);
  const handleClick = () => {
    mainBalance &&
      openModal(<BalanceAdjustmentForm userBalanceData={mainBalance} handleUpdate={refetch} />, modalProps);
  };

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        alignItems: 'center',
        margin: 'auto',
        maxWidth: '600px',
        width: '100%',
        justifyContent: 'space-between',
        padding: 2,
      }}
    >
      <Typography variant='subtitle1'>{t('currentBalance')}:</Typography>
      <TextField
        label={t('balanceEUR')}
        value={balance}
        tabIndex={-1}
        onFocus={(e) => e.target.blur()}
        sx={styles.textField}
        onClick={handleClick}
      />
    </Stack>
  );
};

export default AgentBalance;
